/**
 * Equijump countdown timer web component.
 * Ported from the Fetch theme's CountdownTimer (theme.js line 6347+).
 * Reads target date from data attributes, ticks every second,
 * updates placeholder elements with remaining days/hours/minutes/seconds.
 *
 * Usage:
 *   <countdown-timer data-year="2026" data-month="6" data-day="1"
 *                    data-hour="12" data-minute="0"
 *                    data-hide-timer="false"
 *                    data-complete-message="The wait is over.">
 *     <div data-time-display>
 *       <span data-days>--</span><span data-hours>--</span>
 *       <span data-minutes>--</span><span data-seconds>--</span>
 *     </div>
 *     <div data-message-placeholder></div>
 *   </countdown-timer>
 */
class EquijumpCountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.display = this.querySelector('[data-time-display]');
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.messageEl = this.querySelector('[data-message-placeholder]');

    const { year, month, day, hour, minute, hideTimer, completeMessage } = this.dataset;
    this.target = new Date(`${month}/${day}/${year} ${hour || 0}:${minute || 0}:00`).getTime();
    this.hideTimerOnComplete = hideTimer === 'true';
    this.completeMessage = completeMessage || '';
    this.complete = false;

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    if (this.complete) return;
    const diff = this.target - Date.now();

    if (diff > 0) {
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff / 3600000) % 24);
      const minutes = Math.floor((diff / 60000) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    } else {
      this.complete = true;
      if (this.completeMessage && this.messageEl) {
        this.messageEl.classList.add('aaa-countdown__message--visible');
      }
      if (this.hideTimerOnComplete && this.display) {
        this.display.hidden = true;
      }
      clearInterval(this.interval);
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', EquijumpCountdownTimer);
}
